import { createFileRoute, redirect } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { MyTrainerProfile } from "@/features/trainer/MyTrainerProfile";
import { fetchFeatureFlags } from "@/hooks/useFeatureFlags";

export const Route = createFileRoute("/_app/trainers/$trainerId")({
  // A trainer's profile is hidden while the ilt flag is off (the API 404s it too).
  beforeLoad: async () => {
    const { ilt } = await fetchFeatureFlags();
    if (!ilt) throw redirect({ to: "/my-learning" });
  },
  component: TrainerProfileRoute,
  remountDeps: ({ params }) => params.trainerId,
});

/** A trainer's own profile and stats (LMS-144), from My sessions. Only for trainers. */
function TrainerProfileRoute() {
  const { trainerId } = Route.useParams();
  return (
    <ProtectedRoute
      requiredPermissions={["IltSessions.Deliver"]}
      requiredRoles={["Trainer"]}
      redirectTo="/my-learning"
    >
      <MyTrainerProfile trainerId={trainerId} />
    </ProtectedRoute>
  );
}
